import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { GlobalContext } from "../../Utils/Contexts";
import { MaybeExtended } from "../../Utils/TypeExtensions";
import { useQuery } from "@apollo/client";
import { ObjectUtils } from "../../Utils/ObjectUtils";
import { State } from "../../PilotDuty/PilotDutyPage";
import { getDutyTypes } from "../../GQL/queries";
import { DutyType } from "../../Generated/avroGraphqlDuty";
import { PilotDutyErrorHelper } from "../../Utils/PilotDutyErrorHelper";

interface Props {
    sourceProperty: string;
    initialValue: MaybeExtended<boolean> | MaybeExtended<number> | undefined;
    labelText: string;
    isRequired: boolean;
    payloadProperty: string;
    localState: State;
    dutyItemId: number;
    setLocalState(arg0: State): void;
    onBlurSelects(): void;
}

export default function DutyTypeSelector(props: Props): JSX.Element {
    const { data: dutyTypesDbResult } = useQuery(getDutyTypes);

    const context = useContext(GlobalContext);

    const handleOnChange = (e: React.SyntheticEvent, value: string | DutyType | null): void => {
        if (value) {
            const newPilotDutyItemsList = props.localState.PilotDuty.DutyItems?.map((l) =>
                l && l.id === props.dutyItemId ? { ...l, duty_type_id: (value as DutyType).id } : l,
            );
            props.setLocalState({ ...props.localState, HasChanges: true, PilotDuty: { ...props.localState.PilotDuty, DutyItems: newPilotDutyItemsList } });
        }
    };

    let initialValue: DutyType | undefined;
    let sortedByName = [] as DutyType[];

    if (dutyTypesDbResult) {
        const rawList = dutyTypesDbResult.getDutyTypes.slice() as DutyType[];
        const dutyTypeListToPresent: DutyType[] = ObjectUtils.convertToUppercase(rawList.map((dutyType) => dutyType));

        sortedByName = dutyTypeListToPresent
            .sort((a: DutyType, b: DutyType) => {
                return (a.label ?? "").localeCompare(b.label ?? "");
            })
            .filter((a: DutyType) => a.label);

        initialValue = dutyTypeListToPresent.find((p: DutyType) => p.id === props.initialValue);
    }

    return (
        <>
            <Autocomplete
                value={initialValue === undefined ? null : initialValue}
                options={sortedByName}
                onChange={handleOnChange}
                onBlur={props.onBlurSelects}
                filterSelectedOptions
                renderInput={(params) => (
                    <TextField
                        required={props.isRequired}
                        error={PilotDutyErrorHelper.hasErrors(props.localState.Errors, props.sourceProperty, props.dutyItemId)}
                        helperText={PilotDutyErrorHelper.getErrorMessage(props.localState.Errors, props.sourceProperty, props.dutyItemId)}
                        {...params}
                        label={props.labelText}
                        placeholder="type to search"
                    />
                )}
            />
        </>
    );
}
